// extracted by mini-css-extract-plugin
export default {"customizedFormErrorMessageContainer":"CustomizedFormErrorMessage_customizedFormErrorMessageContainer__A0sR0"};